import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgChartLine(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.25 23.0633V26.75H29.25V29.25H4C3.30964 29.25 2.75 28.6904 2.75 28V2.75H5.25V19.5277L11.8435 12.9342C12.3316 12.4461 13.1231 12.4461 13.6113 12.9342L17.091 16.414L24.9823 8.52271H20.2046V6.02271H28C28.6904 6.02271 29.25 6.58235 29.25 7.27271V15.0682H26.75V10.2905L17.9749 19.0657C17.4867 19.5538 16.6953 19.5538 16.2071 19.0657L12.7274 15.5859L5.25 23.0633Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChartLine);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
